<template>
	<BaseCatalogCategoriesWidget :fetch="{hierarhy_by_position: true}" v-slot="{items}">
		<ul class="nav" ref="navMenuRef">
			<li v-for="(item, index) in items" :key="item.id" @mouseenter="toggleActive(item.id, true)" @mouseleave="handleMouseLeave" :class="[{'has-children': item.children?.length}, { 'active': navActive.includes(item.id)}, 'nav-' + item.code]">
				<BaseUiLink native :prevent-default="(item.children?.length && tabletBreakpoint) ? true : false" :href="item.url_without_domain" @click="toggleActive(item.id)"><span>{{ item.title }}</span><i class="toggle-icon"></i></BaseUiLink>

				<div class="nav-subcategories-container" :class="['nsc-' + index]" v-if="item.children?.length">
					<div class="nav-subcategories-container-inner">
						<template v-for="(subItem, subIndex) in item.children" :key="subItem.id">
							<ul class="nav-level2" v-if="item.code === 'medpom' ? subIndex % 15 === 0 : subIndex === 0">
								<li 
									v-for="child in item.children.slice(subIndex, subIndex + (item.code === 'medpom' ? 15 : item.children.length))"
									:key="child.id" 
									:class="[{'has-children': child.children?.length}, { 'selected': navActive === child.id }, 'nav-' + child.code]"
								>
									<BaseUiLink @click="closeMenu" :href="child.url_without_domain">{{ child.title }}</BaseUiLink>
								</li>
								<template v-if="item.code !== 'medpom' || (item.code == 'medpom' && subIndex >= 15)">
									<li><BaseUiLink @click="closeMenu" :href="item.url_without_domain+'?discount=1'" class="c-discount"><BaseCmsLabel code="discounted_products" /></BaseUiLink></li>
									<li><BaseUiLink @click="closeMenu" :href="item.url_without_domain+'?sort=new'" class="c-new"><BaseCmsLabel code="category_new" /></BaseUiLink></li>
									<li><NuxtLink @click="closeMenu" :to="item.url_without_domain" class="c-all"><BaseCmsLabel code="show_all" /></NuxtLink></li>
								</template>
							</ul>
						</template>
					</div>
					<ClientOnly>
						<LazyBaseCatalogProductsWidget :fetch="{list_code: ['bestsellers_'+item.code], limit: 4, sort: 'order' }" v-slot="{items: menuProducts}">
							<div class="nav-bestsellers-cnt" v-if="menuProducts?.length">
								<BaseCmsLabel class="nav-bestsellers-items-title" code="bestsellers_navigation_title" tag="h2" />
								<div class="nav-bestsellers-items">
									<template v-for="item in menuProducts" :key="item.id">
										<CatalogIndexEntryMenu :item="item" @item-clicked="closeMenu" />
									</template>
								</div>
							</div>
						</LazyBaseCatalogProductsWidget>
					</ClientOnly>
				</div>
			</li>
			<li class="nav-brand"><NuxtLink :href="getAppUrl('manufacturer')"><BaseCmsLabel code="brands" tag="span" /></NuxtLink></li>
		</ul>
	</BaseCatalogCategoriesWidget>
</template>

<script setup>
	const {getAppUrl} = useApiRoutes();
	const {tabletBreakpoint, mobileBreakpoint} = inject('rwd');
	const {onClickOutside} = useDom();
	const navMenuRef = ref(null);
	const navActive = ref([]);

    function toggleActive(id, hover) {	
		if(tabletBreakpoint.value && hover){return};

		if (navActive.value.includes(id)) {
            return navActive.value = navActive.value.filter(activeId => activeId !== id);
        }

		if(tabletBreakpoint.value && !mobileBreakpoint.value){
			navActive.value = [];
		}

        navActive.value.push(id);
	};	

	function handleMouseLeave() {
		if(!tabletBreakpoint.value){
			navActive.value = [];
		}
	}
	function closeMenu() {
		navActive.value = [];
	}

	onClickOutside(navMenuRef, () => {
		if (!mobileBreakpoint.value) {
			navActive.value = [];
		}
	});
</script>

<style lang="less" scoped>
	.nav{
		font-size: 20px; font-weight: normal; list-style: none; margin: 0; padding: 0; display: flex; justify-content: space-between; position: absolute; left: 215px; top: 0; right: 0; height: 100%;
		&>li{
			height: 100%; position: relative;
			&>a{display: flex; height: 100%; align-items: center; color: var(--textColor); text-decoration: none;}
			span{
				display: block;
				&:first-letter{text-transform: uppercase;}
			}
			&>a span{
				padding-top: 31px; position: relative; display: flex; align-items: center; justify-content: center;
				&:after{.pseudo(25px,25px); display: flex; align-items: center; justify-content: center; .icon-patches; top: 0; font: 25px/25px var(--fonti); color: var(--primaryColor);}
			}
		}
		.toggle-icon{display: none;}
		
		li.has-children{
			&>a span{
				padding-top: 31px; position: relative; display: flex; align-items: center; justify-content: center;
				&:after{.pseudo(25px,25px); display: flex; align-items: center; justify-content: center; .icon-patches; top: 0; font: 25px/25px var(--fonti); color: var(--primaryColor);}
			}
			&.active{
				.nav-subcategories-container{opacity: 1; visibility: visible;}
				a{
					&:after{visibility: visible; opacity: 1; z-index: 99999;}
				}
			}
			&>a{
				position: relative;
				&:after{.pseudo(10px,10px); background: white; left: calc(~"50% - 5px"); bottom: -5px; transform: rotate(45deg); z-index: 999; opacity: 0; visibility: hidden; .transition(opacity);}
			}
			.subsubcategories-mobile{display: none;}
		}
		li.active>ul, li:hover>ul{display: block; opacity: 1;}
		li:hover>a, li.selected>a{color: var(--primaryColor);}

		/*.nav-full, .nav-medium{
			position: static;
			&.has-children>a:after{left: 50%;}
			.nav-subcategories-container{width: auto; left: -25px; right: 0; display: flex; text-align: left; padding: 0; z-index: 9999;}
			.nav-subcategories-container-inner{display: flex; text-align: left; width: auto; padding: 25px 70px 25px 40px; flex-grow: 1; justify-content: space-between;}
			//.nav-level2{width: auto; padding-right: 10px;}
		}*/

		/*.nav-medium{
			position: relative;
			.nav-subcategories-container{width: 900px; left: calc(~"50% - 455px");}
			.nav-level2{width: auto;}
		}*/
		.nav-brand{
			&>a span{
				padding-top: 31px; position: relative; display: flex; align-items: center; justify-content: center;
				&:after{.pseudo(25px,25px); .icon-price-tags(); top: 3px; font: 25px/25px var(--fonti); color: var(--primaryColor); display: flex; align-items: center; justify-content: center;}
			}
		}
	}
	.nav-subcategories-container{display: flex; padding: 0; visibility: hidden; opacity: 0; position: absolute; top: 100%; left: -25px; background: white; box-shadow: 0 10px 50px 0 rgba(85,41,122,0.28); z-index: 9999; border-radius: 0 0 2px 2px; min-width: 1205px;}
	.nav-subcategories-container-inner{text-align: left; width: auto; padding: 25px 55px 25px 40px; flex-grow: 1;}
	.nav-level2{
		list-style: none; margin: 0; font-size: 18px; line-height: 1.3; display: block; column-count: 2; width: 100%;
		&:last-child{padding-right: 0;}
		a{
			position: relative; padding: 4px 0; color: var(--textColor); text-decoration: none; display: block;
			@media(min-width: @h){
				&:hover{text-decoration: underline; color: var(--primaryColor);}
			}
		}
	}
	.nav-dermokozmetika{
		&>a span{
			&:after{.icon-dermacosmetic!important; top: 2px !important;}
		}
		.nav-level2{column-count: unset;}
		.nav-subcategories-container{min-width: 885px;}
	}
	.nav-kozm{
		&>a span{
			&:after{.icon-skin-care !important; top: 2px !important;}
		}
		.nav-level2{column-count: unset;}
		.nav-subcategories-container{min-width: 885px;}
	}
	.nav-medpom{
		&>a span{
			&:after{.icon-medicine !important; top: 3px !important;}
		}
		.nav-subcategories-container-inner{display: flex;}
		.nav-subcategories-container{left: -445px}
		.nav-level2{column-count: unset;}
	}
	.nav-1370{
		&>a span{
			&:after{.icon-mother !important; top: 3px !important;}
		}
		.nav-level2{column-count: unset;}
		.nav-subcategories-container{min-width: 885px; left: -430px}
	}
	.nav-pos{
		&>a span{
			&:after{.icon-favorites !important; top: 5px !important; font: 23px/25px var(--fonti) !important;}
		}
		.nav-subcategories-container{min-width: unset;}
		.nav-level2{column-count: unset;}
		.nav-subcategories-container{left: -30px; min-width: 270px;}
		.nav-subcategories-container-inner{padding: 25px 40px;}
		.c-new,.c-discount,.c-all{display: none;}
	}
	.nav-subcategories{content-visibility: auto; contain-intrinsic-size: 550px;}

	//bestsellers
	.nav-bestsellers-cnt{width: 535px; border-left: 1px solid var(--borderColor);}
	.nav-bestsellers-items-title{padding: 25px 40px; font-size: 22px; line-height: 30px; font-weight: 500;}
	:deep(.nav-bestsellers-items){
		display: flex; flex-flow: column;
		.cp{
			margin: 0; border-top: 1px solid var(--borderColor); border-bottom: 1px solid var(--borderColor); padding: 20px 30px; display: flex; border-left: unset !important; border-right: unset !important; margin-top: -1px; flex-flow: row; text-decoration: none; align-items: flex-start; width: 100%; color: var(--textColor);
			&:last-child{border-bottom: 0;}
			@media(min-width: @h){
				&:hover{border-color: var(--borderColor);
					.cp-title{color: var(--primaryColor);}
				}
			}
		}
		.cp-image{
			display: flex; align-items: center; justify-content: center; width: 105px; height: 90px; flex-shrink: 0; position: relative; margin: 8px 0;
			a{width: 100%; height: 100%;}
			img{width: auto; height: auto; max-width: 100%; max-height: 100%;}
		}
		.cp-cnt{padding: 0 0 0 20px;}
		.cp-title{font-size: 18px; line-height: 24px; padding-bottom: 5px; font-weight: 300; color: var(--textColor); text-align: left; padding: 0 0 4px 0;}
		.cp-price{padding: 0; text-align: left; display: flex; align-items: center;}
		.cp-old-price,.cp-price-label{padding-right: 5px; font-size: 14px; line-height: 20px;}
		.cp-discount-price, .cp-current-price{font-size: 20px; line-height: 26px;}
		.cp-discount-price{font-weight: bold;}
		.cp-extra-price-lowest{text-align: left; padding-top: 2px; max-width: 150px;}

		.cp-cnt-top{display: flex; gap: 10px; align-items: flex-start;}
		.cp-wishlist{position: relative; top: auto; right: auto;}
		.cp-wishlist-btn:after{font-size: 20px;}
		.cp-cnt-bottom{display: flex; align-items: center; justify-content: space-between; margin-top: 12px; gap: 10px;}
		.cp-qty-add{margin-top: 0; width: auto; flex-grow: 0; flex-shrink: 0;}
		.cp-btn-addtocart{
			width: 48px; height: 48px; font-size: 0;
			span{padding-left: 0; width: 22px; height: 22px;}
		}

		.cp-badges-container{top: -17px; left: 0; background: transparent; padding: 0;}
		.cp-badge-cnt{background: var(--white); padding: 3px; position: relative; bottom: auto;}
		.cp-badge-discount{font-size: 19px; line-height: 20px;}
		.cp-save{font-size: 8px; line-height: 10px; display: none;}
		.cp-cnt-bottom-price{display: block;}
		.cp-badge-image{width: 38px; height: 38px;}
	}
	//.nav-show-all{display: none;}


	@media (max-width: @l){
		.nav{left: 200px; right: 0; font-size: 18px;
			&>li.has-children{
				&>a span:after{top: 2px;}
			}
		}
		.nav-kozm{
			&>a span:after{top: 1px !important;}
			.nav-subcategories-container{min-width: 825px;}
		}
		.nav-medpom{
			&>a span:after{top: 1px !important}
			.nav-subcategories-container{left: -390px;}
		}
		.nav-1370{
			&>a span:after{top: 1px !important;}
			.nav-subcategories-container{left: -440px;}
		}
		.nav-pos{
			&>a span:after{top: 4px !important;}
			.nav-subcategories-container{left: -25px; min-width: 255px;}
			.nav-subcategories-container-inner{padding: 22px 30px;}
		}

		.nav-subcategories-container{min-width: 1060px; left: -10px;}
		.nav-subcategories-container-inner{width: auto; padding: 25px 30px;}
		.nav-bestsellers-cnt{width: 485px;}
		.nav-bestsellers-items-title{padding: 25px 30px;}
	}

	@media (max-width: @t){
		.nav{
			font-size: 15px; left: 145px;
			&>li{position: unset;}
			&>li.has-children{
				&>a{
					&>span{padding-right: 0; padding-top: 24px;
						&:after{font: 18px/18px var(--fonti); top: 2px;}
					}
				}
				&>a:after{width: 8px; height: 8px; bottom: -4px;}
			}
			/*.nav-full,.nav-medium{
				.nav-subcategories-container{padding: 18px 20px 18px 20px; left: -160px;}
				.nav-level2{padding-right: 20px;
					&:last-child{padding-right: 0;}
				}
			}
			.nav-medium{
				.nav-subcategories-container{width: 740px; left: calc(~"50% - 385px");}
			}*/
			.nav-brand>a span{padding-top: 24px;
				&:after{top: 2px; font: 19px/19px var(--fonti);}
			}
		}
		.nav-subcategories-container{right: 0; min-width: unset!important;}
		.nav-subcategories-container-inner{padding: 20px; width: auto;}
		.nav-level2{font-size: 14px; line-height: 20px;
			a{padding: 4px 0;}
		}
		.nav-bestsellers-cnt{width: 422px;}
		.nav-bestsellers-items-title{padding: 20px; font-size: 18px; line-height: 24px;}
		:deep(.nav-bestsellers-items){
			.cp{padding: 12px 20px;}
			.cp-image{width: 90px; height: 80px;}
			.cp-cnt{padding: 0 0 0 15px;}
			.cp-title{font-size: 14px; line-height: 18px;}
			.cp-discount-price,.cp-current-price{font-size: 16px; line-height: 20px;}
		}
		.nav-kozm{
			&>a span{
				&:after{font: 18px/18px var(--fonti) !important}
			}
			.nav-subcategories-container{left: 0; right: 150px; min-width: unset;}
		}
		.nav-medpom{
			&>a span{
				&:after{font: 18px/18px var(--fonti) !important; top: 1px !important}
			}
			.nav-subcategories-container{left: 0; right: 0; min-width: unset;}
		}
		.nav-1370{
			&>a span{
				&:after{font: 20px/20px var(--fonti) !important; top: 0 !important;}
			}
			.nav-subcategories-container{left: 175px; right: 0; min-width: unset;}
		}
		.nav-pos{position: relative !important;
			&>a span{
				&:after{font: 18px/18px var(--fonti) !important; top: 2px !important;}
			}
			.nav-subcategories-container-inner{padding: 15px 20px; width: auto;}
			.nav-subcategories-container{left: -25px; min-width: 200px;}
		}
	}

	@media (max-width: @tp){
		/*.nav-subcategories-container{left: calc(~"50% - 128px") !important; width: 240px; padding: 18px;}
		.nav-level2{font-size: 14px;}
		.nav{font-size: 13px; left: 112px;
			li.has-children{
				a>span{padding-right: 10px;
					&:after{top: 7px; font: 5px/5px var(--fonti);}
				}
			}
			.nav-full{
				.nav-subcategories-container{padding: 16px 18px; left: -112px !important; width: auto !important;}
				.nav-level2{padding-right: 15px; font-size: 14px;
					a{padding: 4px 0;}
				}
			}
			.nav-medium{
				.nav-subcategories-container{width: 580px; left: calc(~"50% - 295px") !important; padding: 16px 18px; }
				.nav-level{padding-right: 15px;}
			}
		}*/
		
		.nav{
			left: auto; position: relative; flex-direction: column; font-size: 16px; background: #fff;
			&>li{
				border-bottom: 1px solid var(--borderColor);
				&>a{padding: 13px 40px 13px 0;}
				a:after{display: none!important;}
				&.active{
					&>a{color: var(--primaryColor);}
					.nav-subcategories-container{max-height: 2000px;}
					.toggle-icon{
						&:before{display: none;}
					}
				}
			}
			.nav-level2{font-size: 14px!important; text-align: left; margin: 0; column-count: unset;
				a{padding: 0 0 5px !important;}
				li{border: unset;}
			}	
			.subsubcategories-mobile{max-height: 0; visibility: hidden; .transition(all); display: none;}
			.toggle-icon{display: block; position: absolute; top: 20px; right: 15px;}
			ul{
				li,.li-has-children{border-top: 1px solid var(--borderColor); border-bottom: 1px solid var(--borderColor); margin-top: -1px; position: relative;
					&:last-child{border-bottom: 0;}
					.plus{position: absolute; right: 0; top: 16px; width: 12px; height: 2px; background: var(--primaryColor);
						&:after{.pseudo(2px,12px); background: var(--primaryColor); top: 50%; margin-top: -6px; left: 50%; margin-left: -1px;}
					}
				}
				li.has-children{.transition(all);
					&.active{ padding-bottom: 10px; 
						a{color: var(--primaryColor); }
						.subsubcategories-mobile{display: block; visibility: visible; opacity: 1; max-height: 2000px; list-style-type: none; padding-left: 0;
							li{border-bottom: 0; border-top: 0;
								a{padding: 5px 0 !important; font-size: 13px !important; color: var(--textColor);}
							}
						}
						.plus:after{display: none;}
					}
				}
			}
			li.has-children{
				a>span{
					padding-left: 47px; padding-top: 0;
					&:after{width: 20px; height: 20px; left: 15px !important; font: 19px/19px var(--fonti); top: 0;}
				}
			}
		}
		.nav-dermokozmetika>a span:after{top: 0!important;}
		.nav-kozm{
			&>a span{
				&:after{top: 0!important; font: 20px/20px var(--fonti) !important;}
			}
		}
		.nav-medpom{
			&>a span{
				&:after{top: 0!important; font: 20px/20px var(--fonti) !important;}
			}
			.nav-subcategories-container-inner{display: block;}
		}
		.nav-1370{
			&>a span{
				&:after{top: 0!important; left: 15px !important; font: 22px/22px var(--fonti) !important;}
			}
		}
		.nav-pos{
			&>a span{
				&:after{top: 1px!important; left: 15px !important; font: 20px/20px var(--fonti) !important;}
			}
			.nav-subcategories-container-inner{padding: 0 47px 10px; width: auto;}
		}
		
		.nav-show-all{display: block;}
		
		.nav-subcategories-container{
			flex-direction: column; position: relative; left: 0!important; opacity: 1; visibility: visible; overflow: hidden; max-height: 0; padding: 0!important; box-shadow: none; width: 100%; .transition(all);
		}
		.nav-subcategories-container-inner{padding: 0 15px 10px 47px;}
		.nav-bestsellers-cnt{width: 100%; border-top: 1px solid var(--borderColor);}
		.nav-bestsellers-items-title{padding: 22px 15px 10px;}
		:deep(.nav-bestsellers-items){
			.cp{padding: 15px 13px 23px;}
			.cp-title{padding-bottom: 0;}
			.cp-cnt-bottom{flex-flow: column; align-items: flex-start; justify-content: flex-start; margin-top: 10px; gap: 5px;}
			.cp-wishlist{width: 20px; flex-grow: 0; flex-shrink: 0;}
			.cp-wishlist-btn:after{display: block!important; font-size: 18px;}
			.cp-discount-price, .cp-current-price{font-size: 13px; line-height: 17px;}
			.cp-qty{
				width: 122px;
				.wp-btn-qty{
					width: 40px; height: 40px; min-width: auto; min-height: auto;
					&:before{width: 12px; margin-left: -6px;}	
				}
				.wp-btn-inc:after{display: block!important; height: 12px; margin-top: -6px;}
				input{height: 40px; padding: 0 40px;}
			}
			.cp-btn-addtocart{
				width: 40px; height: 40px;
				span{
					padding-left: 0!important;
					&:before{width: 20px; height: 20px; font-size: 18px; line-height: 20px; top: 1px;}
				}	
			}
			.cp-unit{font-size: 10px;}
			.cp-extra-price-lowest{max-width: inherit;}
			.cp-image{width: 105px; height: 105px;}
		}
		.nav>li.nav-brand>a span{
			padding-left: 47px; padding-top: 0;
			&:after{left: 15px; width: 20px; height: 20px; font-size: 20px; line-height: 20px;}
		}
	}

	@media (max-width: @m){
		:deep(.nav-bestsellers-items){
			.cp-image{min-height: inherit;}
		} 
			
	}
</style>
